import { render, staticRenderFns } from "./overdueToDoNotificationItem.vue?vue&type=template&id=6820624a"
import script from "./overdueToDoNotificationItem.vue?vue&type=script&lang=ts"
export * from "./overdueToDoNotificationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports